/* custom-cl-accordion — delegated, accessible accordion (smooth grid-rows reveal).
   Markup:
     <div class="cl-acc" data-cl-acc[ data-cl-acc-single]>
       <div class="cl-acc__row[ is-open]">
         <button class="cl-acc__trigger" aria-expanded="true|false" data-cl-acc-trigger>…</button>
         <div class="cl-acc__panel"><div class="cl-acc__inner">…</div></div>
       </div>
     </div>
   data-cl-acc-single → opening one row closes its siblings.
   Optional callback: rows fire a `cl-acc:toggle` event (detail.open, detail.row) for syncing (bundle image, etc.). */
(function () {
  if (window.__clAccBound) return;           // idempotency: this file can be loaded by multiple sections on one page
  window.__clAccBound = true;
  function setRow(row, open) {
    if (!row) return;
    var btn = row.querySelector('[data-cl-acc-trigger]');
    row.classList.toggle('is-open', open);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    row.dispatchEvent(new CustomEvent('cl-acc:toggle', { bubbles: true, detail: { open: open, row: row } }));
  }

  document.addEventListener('click', function (e) {
    if (!e.target || typeof e.target.closest !== 'function') return;
    var btn = e.target.closest('[data-cl-acc-trigger]');
    if (!btn) return;
    var row = btn.closest('.cl-acc__row');
    if (!row) return;
    e.preventDefault();
    var acc = btn.closest('[data-cl-acc]');
    var willOpen = !row.classList.contains('is-open');
    if (acc && acc.hasAttribute('data-cl-acc-single') && willOpen) {
      acc.querySelectorAll('.cl-acc__row.is-open').forEach(function (r) { if (r !== row) setRow(r, false); });
    }
    setRow(row, willOpen);
  });

  /* a11y: link each trigger to its panel (aria-controls + region role + unique id). */
  var accId = 0;
  function enhance() {
    document.querySelectorAll('.cl-acc__row').forEach(function (row) {
      var btn = row.querySelector('[data-cl-acc-trigger]');
      var panel = row.querySelector('.cl-acc__panel');
      if (!btn || !panel || panel.id) return;
      panel.id = 'cl-acc-panel-' + (++accId);
      btn.setAttribute('aria-controls', panel.id);
      panel.setAttribute('role', 'region');
    });
  }
  if (document.readyState !== 'loading') enhance();
  else document.addEventListener('DOMContentLoaded', enhance);
  document.addEventListener('shopify:section:load', enhance);
})();
